const firstName = () => '<b>[firstname]</b>'
const lastName = () => '<b>[lastname]</b>'
const tel = () => '<b>[telephone no.]</b>'
const memberType = () => '<b>[type of member]</b>'
const birthDate = () => '<b>[birthdate]</b>'
const code = () => '<b>[code]</b>'
const discount = () => '<b>[discount]</b>'
const expireCode = () => '<b>[expire code]</b>'
const spending = () => '<b>[spending]</b>'

export default {
  firstName,
  lastName,
  tel,
  memberType,
  birthDate,
  code,
  discount,
  expireCode,
  spending
}
